export default [
  {
    name: 'ounces',
    code: 'oz'
  },
  {
    name:'pounds',
    code: 'lb'
  },
  {
    name: 'grams',
    code: 'g'
  },
  {
    name: 'kilograms',
    code: 'kg'
  }
]